import React from 'react';
import {useSelector} from "react-redux";

import Row from './Row';

export default function () {
    const items = useSelector(state => Array.isArray(state.challenges) ? state.challenges : []);

    return (
        <div className="table-responsive">
            <table className="table table-bordered table-hover">
                <thead>
                <tr className="text-center">
                    <th scope="col">ID</th>
                    <th scope="col">Name</th>
                    <th scope="col">Code</th>
                    <th scope="col">Latest Version</th>
                    <th scope="col">Status</th>
                    <th scope="col">Is Free</th>
                    <th scope="col">Actions</th>
                </tr>
                </thead>
                <tbody>
                {items.map(item=> {
                    return (
                        <Row
                            key={item.id}
                            item={item}
                        />
                    );
                })}
                </tbody>
            </table>
        </div>
    );
};
